import type * as Style from '../../index.js'
import { RuleId } from '../../values/index.js'

export const Props = (props: any = {}) => ({
  url: props.url
})
export type Reference = RuleId
export const validate = () => true
export type Props = ReturnType<typeof Props>
export const fix = (props: Props, styles: Style.Rule[]) => props
export const label = 'Graphic'
export const type = 'graphic'
export const category = 'basic'
export const forms = [
  {
    id: 'graphic',
    label: 'Graphic',
    extractProperties: (props: Props) => props,
    validate: () => true
  }
]
